import {FC, useState, useEffect, useContext} from 'react'
import {IHandleFilterCallbackFunction, ILanguage} from '../../types/common'
import {registerLocale} from 'react-datepicker'
import {pl, enUS} from 'date-fns/locale'
import MultiSelectDropdown from '../../common/MultiSelectDropdown'
import ActiveFilters from './ActiveFilters'
import YearMonthPicker from '../../common/YearMonthPicker'
import InfoBox from '../../common/InfoBox'
import {useTranslation} from 'react-i18next'
import {SessionContext, SessionContextType} from '../../common/ctx/SessionContext'

registerLocale('pl', pl)
registerLocale('en', enUS)

const FiltersALL: FC<{
    language: ILanguage
    handleFilter: IHandleFilterCallbackFunction
    ctx: any
}> = ({language, handleFilter, ctx}) => {
    const {t} = useTranslation()
    const sessionCtx: SessionContextType = useContext(SessionContext)
    const [excludedDays, setExcludedDays] = useState<Array<Date>>()
    const [selectedDate, setSelectedDate] = useState<Date | undefined>()
    const [datePickerMinDate, setDatePickerMinDate] = useState<Date | undefined>()
    const [datePickerMaxDate, setDatePickerMaxDate] = useState<Date | undefined>()
    const [selectedKinds, setSelectedKinds] = useState<Array<string>>([])
    const [searchByName, setSearchByName] = useState<string>('')
    const [addToFavoritesInfoBox, setAddToFavoritesInfoBox] = useState<boolean>(false)
    const [kindTooltipTxt, setKindTooltipTxt] = useState<string>('')

    const defaultFilters = {
        kind: [
            {value: 'fio', label: 'label.kind.FIO'},
            {value: 'ufk', label: 'label.kind.UFK'},
            {value: 'ofe', label: 'label.kind.OFE'},
            {value: 'dfe', label: 'label.kind.DFE'},
        ],
    }

    useEffect(() => {
        ctx.isDefault()
    }, [])

    useEffect(() => {
        setSelectedKinds(ctx.kinds)
        handleFilter(ctx.kinds, 'kind')
    }, [ctx.kinds])

    useEffect(() => {
        setDatePickerMaxDate(ctx.maxDate)
        setDatePickerMinDate(ctx.minDate)
    }, [ctx.minDate, ctx.maxDate])

    // useEffect(() => {
    //     setSelectedDate(ctx.today)
    // }, [ctx.today])

    useEffect(() => {
        setExcludedDays(ctx.holiday)
    }, [ctx.holiday])

    useEffect(() => {
        if (selectedKinds) {
            setKindTooltipTxt(() => {
                const filtered = defaultFilters.kind.filter((item: any) => {
                    if (selectedKinds.includes(item.value)) {
                        return item
                    }
                })

                return filtered.map((item) => t(item.label)).join(', ')
            })
        }
    }, [selectedKinds])

    const handleSearch = () => {
        handleFilter(searchByName, 'name')
    }

    const handleAddToFavoritesInfoBoxCloseBtn = () => {
        ctx.setShowFavoritesInfoBox(false)
        setAddToFavoritesInfoBox(false)
    }

    useEffect(() => {
        handleSearch()
    }, [searchByName])

    const handleKindChange = (value: string): void => {
        setSelectedKinds((prevState: Array<string>) => {
            const items = [...prevState]
            if (items.includes(value)) {
                return items.filter((item) => item != value)
            } else {
                items.push(value)
                return items
            }
        })

        ctx.setKinds((prevState: Array<string>) => {
            const items = [...prevState]
            if (items.includes(value)) {
                return items.filter((item) => item != value)
            } else {
                items.push(value)
                return items
            }
        })
    }

    useEffect(() => {
        if (ctx.showFavoritesInfoBox) {
            setAddToFavoritesInfoBox(true)
        }
    }, [ctx.showFavoritesInfoBox])

    return (
        <>
            <section id="container-toolbar" className="flex">
                <div className="title-fund flex">
                    <h2>{t('label.catalog.all.title')}</h2>
                </div>
                {sessionCtx?.getItem(ctx.STORAGE_KEY) !== 'hidden' && (
                    <InfoBox
                        title={
                            <span>
                                {' '}
                                {t('label.infobox.filters.save')} <br />
                                {t('label.infobox.filters.continue')}{' '}
                            </span>
                        }
                        onCloseCallback={() => {
                            sessionCtx.setItem(ctx.STORAGE_KEY, 'hidden')
                        }}
                    />
                )}
                <div className="filter-bar flex">
                    <div className="up-filter-bar">
                        <div className="grid-column flex">
                            <div className="datepickers-item flex">
                                <label className="datepickers-item-label">{t('label.datepicker.title')}</label>
                                <YearMonthPicker
                                    language={language}
                                    selectedDate={selectedDate}
                                    setSelectedDate={setSelectedDate}
                                    datePickerMinDate={datePickerMinDate}
                                    datePickerMaxDate={datePickerMaxDate}
                                    excludeDates={excludedDays}
                                    withCurrentDate={true}
                                    filterDate={(date) => {
                                        return date.getDay() !== 0 && date.getDay() !== 6
                                    }}
                                    onDateChangeCallback={(date) => {
                                        ctx.setDate(date)
                                    }}
                                />
                            </div>
                            <div className="filter-item input-rwd">
                                <label className="filter-item-label">{t('label.kind.title')}</label>
                                <MultiSelectDropdown
                                    options={defaultFilters.kind}
                                    selected={selectedKinds}
                                    toggleOption={handleKindChange}
                                    forLabel="filter_kind"
                                    tooltipTxt={kindTooltipTxt}
                                    visibletooltip={true}
                                />
                            </div>
                            <div className="start-search flex">
                                <label className="filter-item-label">{t('label.search.title')}</label>
                                <div className="search-bar input-rwd flex">
                                    <input
                                        className="search-bar-input flex"
                                        type="text"
                                        placeholder={t('label.search.placeholder')}
                                        onChange={(event) => setSearchByName(event.target.value)}
                                    />
                                    <span className="search-bar-icon-btn" onClick={handleSearch}></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*<div className="filters-delete flex">*/}
                    {/*    <div className="delete-all flex">*/}
                    {/*        <div className="link-delete">Wyczyść filtry</div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </section>
            <ActiveFilters ctx={ctx} filters={defaultFilters} />
            {addToFavoritesInfoBox && (
                <InfoBox
                    title={'label.infobox.favorites.append'}
                    onCloseCallback={handleAddToFavoritesInfoBoxCloseBtn}
                    sticky={true}
                />
            )}
        </>
    )
}

export default FiltersALL
